export default {
  login: true,
  currentUser: {
    id: '',
    role: '',
    name: '',
    email: ''
  },
  userModel: {},
  view: {additionalDialog:false}
}
